// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { chain, RequestDataFromApi } from "@insite/client-framework/Store/Data/Categories/Handlers/LoadCategories";
import { xngGetCategories } from "@stoneage/App/Services/Category/CategoryService";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";

// XNG-Changes
// https://xngage.atlassian.net/browse/SAINC-1798
const XngRequestDataFromApi: typeof RequestDataFromApi = async props => {
    try {
        props.apiResult = await xngGetCategories(props.apiParameter);
    } catch (error) {
        if (error?.status === 404) {
            if (props.apiParameter.startCategoryId) {
                props.dispatch({
                    type: "Data/Categories/FailedToLoadCategory",
                    categoryId: props.apiParameter.startCategoryId,
                    status: error.status,
                });
            }
            return false;
        }
        throw error;
    }
};

replaceInChain(chain, RequestDataFromApi, XngRequestDataFromApi);
